import axios from "axios";
import Partner from "../../adapters/partner-adapter";
import store from "./../index";

export default {
  namespaced: true,
  state: {
    partners: [],
  },

  mutations: {
    setPartners(state, payload) {
      state.partners = payload;
    },
  },
  actions: {
    getPartners({ commit }) {
      store.commit("setLoader", true);
      return axios
        .get(`/home/partners`)
        .then((response) => {
          const res = response.data.data.partners;
          let lang = store.state.lang;
          commit(
            "setPartners",
            res.map((i) => {
              return new Partner(i, lang);
            })
          );
          return true;
        })
        .catch(() => {
          return false;
        });
    },
  },
};
